import React from "react";
import ReactDOMServer from "react-dom/server";

import {
  isLumberCommodity,
  isPanelsCommodity,
} from "../../../../utils/loadTypeUtils";

import { InboundPODBody } from "./InboundPODBody";
import { LumberPODBody } from "./LumberPODBody";

const getPODBody = (commodity) => {
  if (isLumberCommodity(commodity) || isPanelsCommodity(commodity)) {
    return LumberPODBody;
  }
  return InboundPODBody;
};

export const getInboundPODBody = (
  record,
  enclosePhotos,
  encloseAttachments
) => {
  const PODComponent = getPODBody(record.reloadYardCommodityId);

  return ReactDOMServer.renderToString(
    <PODComponent
      record={record}
      enclosePhotos={enclosePhotos}
      encloseAttachments={encloseAttachments}
    />
  );
};
